import { getFetch, postFetch, putFetch, deleteFetch } from '../utils/fetch';
import { AREA_API } from './config';

export function getList(query) {
  return getFetch(`${AREA_API()}`, query);
}

export function getOne(_id) {
  return getFetch(`${AREA_API()}/${_id}`);
}

export function updateOne(_id, data = {}) {
  return putFetch(`${AREA_API()}/${_id}`, data);
}

export function deleteOne(_id) {
  return deleteFetch(`${AREA_API()}/${_id}`);
}

export function create(data) {
  return postFetch(`${AREA_API()}`, data);
}

export function exportData(query) {
  return getFetch(`${AREA_API()}/export`, query);
}



// WEBPACK FOOTER //
// ./src/api/areaApi.js